var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.ServerError)?_c('ServerError'):_vm._e(),_c('v-layout',{attrs:{"wrap":"","justify-center":""}},[_c('v-flex',[_c('PageLoader',{attrs:{"storage":_vm.appLoading,"contain":true}}),_c('apexchart',{attrs:{"width":"380","type":"pie","options":_vm.chartOptions,"series":_vm.chatData}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }